import {all, call, put, select, take, takeEvery, takeLatest, takeLeading} from 'redux-saga/effects'

import history from '../../history'

import * as addToLookActions from '../../actions/addToLook'
import * as lookbuilderActions from '../../actions/lookbuilder'
import * as lookbuilderSelectors from '../../store/lookbuilder'
import * as URLS from '../../urls'
import {getProductSet} from '../../api/product'
import {getCategoryByTags, normalizeProductObject} from './helpers'

/**
 * Handles fetching the products by product slugs to load in the planner view. Checks to see if
 * there are any queued products to be fetched. If not, do nothing.
 */
export function* getProductSetsWorker() {
  const productsToFetch = yield select(lookbuilderSelectors.queuedProductSlugsToFetch)
  if (productsToFetch.length === 0) {
    return
  }

  yield put(lookbuilderActions.getProductSetsPending())
  try {
    const responseArr = yield all(productsToFetch.map((slug) => call(getProductSet, slug)))
    const products = responseArr.map(({json}) => json)
    const productsByCategory = products.map(normalizeProductObject).reduce(
      (output, product) => ({
        ...output,
        [getCategoryByTags(product.subcategories)]: product,
      }),
      {},
    )

    yield put(lookbuilderActions.getProductSetsSuccess(productsByCategory))
  } catch {
    yield put(lookbuilderActions.getProductSetsFailure())
  }
}

export function* getProductSetsSaga() {
  yield takeLatest(lookbuilderActions.START_LOOKBUILDING, getProductSetsWorker)
}

/**
 * Handles error action dispatched when fetching default product sets fails.
 */
export function* handleGetProductSetsFailureWorker() {
  yield call(window.alert, 'We encountered an error. Please try again.')
}

export function* handleGetProductSetsFailureSaga() {
  yield takeEvery(lookbuilderActions.GET_PRODUCT_SETS_FAILURE, handleGetProductSetsFailureWorker)
}

/**
 * Handles save to look action when a user clicks the appropriate button
 * @generator
 */
export function* saveLookbuilderLookWorker() {
  const products = yield select(lookbuilderSelectors.addToLookProducts)

  yield put(addToLookActions.addLookbuilderProductsToLook(products))

  yield take(lookbuilderActions.COPY_LOOKBUILDER_LOOK)
  yield put(lookbuilderActions.queueLookbuilderProducts(products.map(({slug}) => slug)))
  yield call(history.push, URLS.LOOKBUILDER)
}

export function* saveLookbuilderLookSaga() {
  yield takeLeading(lookbuilderActions.SAVE_LOOKBUILDER_LOOK, saveLookbuilderLookWorker)
}

/**
 * Reset lookbuilder's state once we successfully add the look to the dashboard
 */
export function* addToLookSuccessWorker() {
  yield put(lookbuilderActions.resetLookbuilderLook())
}

export function* addToLookSuccessSaga() {
  yield takeEvery(addToLookActions.ADD_TO_LOOK_SUCCESS, addToLookSuccessWorker)
}
